module.exports = __webpack_public_path__ + "Susan Han-6db191dd.png";